import { cn } from "@/lib/utils/cn";

const Skeleton = ({ className, ...props }: React.ComponentProps<"div">) => {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-md bg-muted dark:bg-muted/20", className)}
      {...props}
    />
  );
};

export { Skeleton };
